import BodyWrapper from "./shared/components/BodyWrapper";
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import Home from "./pages/Home";
import Contact from "./pages/Contact";
import Profile from "./pages/Profile";
import Evidences from './pages/Evidences';

function App() {
  return (
    <>
      <Router>
        <Switch>
          <Route exact path="/contacto" component={Contact}/>
          <Route exact path="/profile" component={Profile}/>
          <Route path="/evidencias" component={Evidences}/>
          <Route exact path="/" component={Home}/>
        </Switch>
      </Router>
    </>
  );
}

export default BodyWrapper(App);
